import { render, staticRenderFns } from "./ReferenceEngine.vue?vue&type=template&id=5155b55c&scoped=true"
import script from "./ReferenceEngine.vue?vue&type=script&lang=js"
export * from "./ReferenceEngine.vue?vue&type=script&lang=js"
import style0 from "./ReferenceEngine.vue?vue&type=style&index=0&id=5155b55c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5155b55c",
  null
  
)

export default component.exports